import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

///////////////////////////////////////////////////////////////////////// PLUGINS

import VuePouchDB from 'vue-pouch-db';
Vue.use(VuePouchDB)

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('vue-select', vSelect)

import Toasted from 'vue-toasted'
import VueToasted from 'vue-toasted';

Vue.use(VueToasted, {
    iconPack : 'fontawesome' // defaults to material. material|fontawesome|custom-class
});
Vue.use(Toasted)

import SortedTablePlugin from "vue-sorted-table";
Vue.use(SortedTablePlugin);

import JsonViewer from 'vue-json-viewer'
Vue.use(JsonViewer)

import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

Vue.config.productionTip = false

///////////////////////////////////////////////////////////////////////// LOCAL FILTERS

Vue.filter('capitalize', function (value) {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('initial', function (value, length=1, uppercased=true) {
    if (!value) return ''
    value = value.toString()
    let sub = value.slice(0, length)
    return uppercased ? sub.toUpperCase() : sub
})

///////////////////////////////////////////////////////////////////////// ROUTAGE

// router.beforeEach((to, from, next) => {
//     console.log(to, from, next);
    // let before = from.name || from.path
    // let after = to.name || to.path
    // let msg = `${before} -> ${after}`
    // Vue.toasted.show(msg, { duration: 2000 });
//    next();
// });

///////////////////////////////////////////////////////////////////////// LOCAL PLUGINS

import { databases } from '@/lib/plugins/databases.js';
Vue.use(databases);

import Meta from '@/lib/plugins/meta.js';
Vue.use(new Meta(databases))

import AppState from '@/lib/plugins/appstate.js';
Vue.use(new AppState())

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
